app.directive('userexistsValidation', function(userService) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function userexistsValidation(email) {
                if (email == "") {
                    ctrl.$setValidity('userexistsInvalid', true);
                } else {
                    var params = {};
                    if (typeof scope.userId != "undefined")
                        params.id = scope.userId;
                    params.email = email;

                    var promise = userService.exists(params);

                    promise.then(
                        function(payload) {
                            ctrl.$setValidity('userexistsInvalid', !payload.data);
                        });

                    console.log(scope.userId);
                }

                return email;
            }

            ctrl.$parsers.push(userexistsValidation);
        }
    };
});
